import { render, staticRenderFns } from "./searchCommodity.vue?vue&type=template&id=8b49a152&scoped=true"
import script from "./searchCommodity.vue?vue&type=script&lang=ts"
export * from "./searchCommodity.vue?vue&type=script&lang=ts"
import style0 from "./searchCommodity.vue?vue&type=style&index=0&id=8b49a152&prod&lang=less&scoped=true"
import style1 from "./searchCommodity.vue?vue&type=style&index=1&id=8b49a152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b49a152",
  null
  
)

export default component.exports